import { render, staticRenderFns } from "./PlaylistTags.vue?vue&type=template&id=b162e180"
import script from "./PlaylistTags.vue?vue&type=script&lang=js"
export * from "./PlaylistTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports